const swapsMainNet = new Map();
const swapsTestNet = new Map();

swapsMainNet.set('YodeSwap', {
  url: 'https://app.yodeswap.dog/exchange/swap?outputCurrency=:token',
  urlLp: 'https://app.yodeswap.dog/exchange/add/:token',
});

export { swapsMainNet, swapsTestNet };
